/* Checks to see if the provided string contains any special characters if so returns true otherwise false */
export const containsSpecialCharacters = function (str){
    var regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
	return regex.test(str);
}

export const containsSpecialCharactersLocation = function (str){
    var regex = /[!@#$%^&*_+\=\[\]{};:"\\|<>\?]/g;
	return regex.test(str);
}